import React from "react";
import { useAuth } from "../context/AuthContext";
import { Eye, ShieldAlert, ArrowLeft, User, UserX } from "lucide-react";

export default function EmulationBanner() {
  const { isEmulating, viewMode, setViewMode, realUser } = useAuth();

  if (!isEmulating) return null;

  return (
    <div className="sticky top-0 z-[999] bg-[#0c0803] border-b border-amber-500/40 text-amber-300 px-4 py-2 shadow-2xl flex items-center justify-between flex-wrap gap-3 font-mono text-xs backdrop-blur-md">
      <div className="flex items-center gap-2.5">
        <div className="w-2 h-2 rounded-full bg-amber-400 animate-ping" />
        <div className="flex items-center gap-1.5 font-bold uppercase font-chakra tracking-wider text-amber-400">
          <Eye className="w-4 h-4" />
          <span>MOD SIMULARE ACTIV:</span>
        </div>
        <span className="bg-amber-500/10 px-2 py-0.5 border border-amber-500/30 text-amber-200">
          {viewMode === "member" ? "Membru Obișnuit (Fără drepturi VIP / Staff)" : "Vizitator (Neautentificat)"}
        </span>
        <span className="text-zinc-500 text-[11px] hidden md:inline">
          (Utilizator real: <strong className="text-white">{realUser?.username}</strong> [{realUser?.role}])
        </span>
      </div>

      <div className="flex items-center gap-2">
        {viewMode !== "member" ? (
          <button 
            onClick={() => setViewMode("member")}
            className="px-2.5 py-1 bg-[#141008] hover:bg-[#1a140a] border border-amber-500/30 hover:border-amber-400 text-amber-300 font-chakra font-bold text-xs uppercase flex items-center gap-1 transition-all"
          >
            <User className="w-3.5 h-3.5" />
            <span>Vezi ca Membru</span>
          </button>
        ) : (
          <button 
            onClick={() => setViewMode("guest")}
            className="px-2.5 py-1 bg-[#141008] hover:bg-[#1a140a] border border-amber-500/30 hover:border-amber-400 text-amber-300 font-chakra font-bold text-xs uppercase flex items-center gap-1 transition-all"
          >
            <UserX className="w-3.5 h-3.5" />
            <span>Vezi ca Vizitator</span>
          </button>
        )}

        <button 
          onClick={() => setViewMode("admin")}
          className="px-3 py-1 bg-amber-500 hover:bg-amber-400 text-black font-chakra font-black text-xs uppercase flex items-center gap-1.5 shadow-[0_0_10px_rgba(245,158,11,0.4)] transition-all cursor-pointer"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          <span>REVINO LA ADMINISTRATOR</span>
        </button>
      </div>
    </div>
  );
}
